module.exports = __webpack_public_path__ + "static/media/qbpro2020.4329ec3f.png";